<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <b-container fluid="">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class=""></span>
          <span>Convenios Membresias</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>???</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12"> <br /><br /> </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div>
            <b-tabs content-class="mt-3">
              <!--
              **********************************************
              -->
              <b-tab
                title="Catalogo Tipo Membresia"
                @click="tabConsulta(1)"
                active
              >
                <b-row>
                  <b-col cols="12">
                    <b-table
                      hover
                      responsive="true"
                      thead-tr-class="columnas"
                      class="parrafos"
                      id="tabla_catalogoTipoMembresia"
                      :items="catalogoTipoMembresia"
                      :fields="titTipoMem"
                      :per-page="registrosPorPagina"
                      :current-page="paginaActual"
                    >
                      <template v-slot:cell(registroActivo)="row">
                        <b-alert
                          show
                          variant="success"
                          v-if="row.item.registroActivo == true"
                          >ACTIVO</b-alert
                        >
                        <b-alert show variant="danger" v-else>INACTIVO</b-alert>
                      </template>
                      <template v-slot:cell(fechaAlta)="row">
                        {{ row.item.fechaAlta | formatoFecha }}
                      </template>
                      <template v-slot:cell(fechaModificacion)="row">
                        {{ row.item.fechaModificacion | formatoFecha }}
                      </template>
                      <template v-slot:cell(editar)="row">
                        <b-button
                          variant="outline-info"
                          @click="editarFormularioTipoMembresia(row)"
                          >Editar</b-button
                        >
                      </template>
                    </b-table>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12">
                    <br />
                    <br />
                    <br />
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <h3 class="text-left">Crear Tipo de Membresia</h3>
                    <validation-observer
                      ref="post_tipo_membresia"
                      v-slot="{ handleSubmit }"
                    >
                      <b-form
                        @submit.stop.prevent="
                          handleSubmit(postGuardarTipoMembresia)
                        "
                      >
                        <br />
                        <br /><br />

                        <b-row class="text-left">
                          <b-col>
                            <validation-provider
                              name="tipoMembresia"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label
                                >Tipo de Membresia:<validacion
                                  >*</validacion
                                ></label
                              >
                              <b-form-input
                                v-model="tipoMembresia.descripcion"
                                placeholder="Tipo de Membresia"
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                                required
                              ></b-form-input>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col> </b-col>
                          <b-col> </b-col>
                        </b-row>
                        <b-row class="text-left">
                          <b-col>
                            <br />
                            <br />
                            <b-button variant="primary" type="submit"
                              >Guardar</b-button
                            >
                          </b-col>
                          <b-col> </b-col>
                          <b-col> </b-col>
                        </b-row>
                      </b-form>
                    </validation-observer>
                  </b-col>
                  <b-col cols="6">
                    <h3 class="text-left">Editar Tipo de Membresia</h3>

                    <validation-observer
                      ref="put_tipo_membresia"
                      v-slot="{ handleSubmit }"
                    >
                      <b-form
                        @submit.stop.prevent="
                          handleSubmit(putActualizarTipoMembresia)
                        "
                      >
                        <br />
                        <br /><br />

                        <b-row class="text-left">
                          <b-col>
                            <label>Id:<validacion>*</validacion></label
                            ><b-form-input
                              v-model="tipoMembresiaPut.idConvenioTipoMembresia"
                              disabled
                            ></b-form-input
                          ></b-col>
                          <b-col>
                            <validation-provider
                              name="tipoMembresiaPut"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label
                                >Tipo de Membresia:<validacion
                                  >*</validacion
                                ></label
                              >
                              <b-form-input
                                v-model="tipoMembresiaPut.descripcion"
                                :disabled="
                                  tipoMembresiaPut.idConvenioTipoMembresia ==
                                  null
                                "
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                                required
                              ></b-form-input>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <label>Estatus:<validacion>*</validacion></label>
                            <b-form-select
                              v-model="tipoMembresiaPut.registroActivo"
                              :disabled="
                                tipoMembresiaPut.idConvenioTipoMembresia == null
                              "
                            >
                              <b-form-select-option value="true"
                                >Activo</b-form-select-option
                              >
                              <b-form-select-option value="false"
                                >Inactivo</b-form-select-option
                              >
                            </b-form-select>
                          </b-col>
                        </b-row>
                        <b-row class="text-left">
                          <b-col>
                            <br />
                            <br />
                            <b-button
                              variant="primary"
                              type="submit"
                              :disabled="
                                tipoMembresiaPut.idConvenioTipoMembresia == null
                              "
                              >Editar</b-button
                            >
                          </b-col>
                          <b-col> </b-col>
                          <b-col> </b-col>
                        </b-row>
                      </b-form>
                    </validation-observer>
                  </b-col>
                </b-row>

                <b-row>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br
                /></b-row>
              </b-tab>

              <!--
              **********************************************
              -->
              <b-tab title="Catalogo Origen Membresia" @click="tabConsulta(2)">
                <b-row>
                  <b-col cols="12">
                    <b-table
                      hover
                      responsive="true"
                      thead-tr-class="columnas"
                      class="parrafos"
                      id="tabla_catalogoOrigenMembresia"
                      :items="catalogoOrigenMembresia"
                      :fields="titOrigenMem"
                      :per-page="registrosPorPagina"
                      :current-page="paginaActual"
                    >
                      <template v-slot:cell(registroActivo)="row">
                        <b-alert
                          show
                          variant="success"
                          v-if="row.item.registroActivo == true"
                          >ACTIVO</b-alert
                        >
                        <b-alert show variant="danger" v-else>INACTIVO</b-alert>
                      </template>
                      <template v-slot:cell(fechaAlta)="row">
                        {{ row.item.fechaAlta | formatoFecha }}
                      </template>
                      <template v-slot:cell(fechaModificacion)="row">
                        {{ row.item.fechaModificacion | formatoFecha }}
                      </template>
                      <template v-slot:cell(editar)="row">
                        <b-button
                          variant="outline-info"
                          @click="editarFormularioOrigenMembresia(row)"
                          >Editar</b-button
                        >
                      </template>
                    </b-table>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12">
                    <br />
                    <br />
                    <br />
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <h3 class="text-left">Crear Origen Membresia</h3>
                    <validation-observer
                      ref="post_origen_membresia"
                      v-slot="{ handleSubmit }"
                    >
                      <b-form
                        @submit.stop.prevent="
                          handleSubmit(postGuardarOrigenMembresia)
                        "
                      >
                        <br />
                        <br /><br />

                        <b-row class="text-left">
                          <b-col>
                            <validation-provider
                              name="origenMembresia"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label
                                >Origen Membresia:<validacion
                                  >*</validacion
                                ></label
                              >
                              <b-form-input
                                v-model="origenMembresia.descripcion"
                                placeholder="Origen Membresia"
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                                required
                              ></b-form-input>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col> </b-col>
                          <b-col> </b-col>
                        </b-row>
                        <b-row class="text-left">
                          <b-col>
                            <br />
                            <br />
                            <b-button variant="primary" type="submit"
                              >Guardar</b-button
                            >
                          </b-col>
                          <b-col> </b-col>
                          <b-col> </b-col>
                        </b-row>
                      </b-form>
                    </validation-observer>
                  </b-col>
                  <b-col cols="6">
                    <h3 class="text-left">Editar Origen Membresia</h3>

                    <validation-observer
                      ref="put_origen_membresia"
                      v-slot="{ handleSubmit }"
                    >
                      <b-form
                        @submit.stop.prevent="
                          handleSubmit(putActualizarOrigenMembresia)
                        "
                      >
                        <br />
                        <br /><br />

                        <b-row class="text-left">
                          <b-col>
                            <label>Id:<validacion>*</validacion></label
                            ><b-form-input
                              v-model="
                                origenMembresiaPut.idConvenioOrigenMembresia
                              "
                              disabled
                            ></b-form-input
                          ></b-col>
                          <b-col>
                            <validation-provider
                              name="origenMembresiaPut"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label
                                >Tipo de Membresia:<validacion
                                  >*</validacion
                                ></label
                              >
                              <b-form-input
                                v-model="origenMembresiaPut.descripcion"
                                :disabled="
                                  origenMembresiaPut.idConvenioOrigenMembresia ==
                                  null
                                "
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                                required
                              ></b-form-input>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <label>Estatus:<validacion>*</validacion></label>
                            <b-form-select
                              v-model="origenMembresiaPut.registroActivo"
                              :disabled="
                                origenMembresiaPut.idConvenioOrigenMembresia ==
                                null
                              "
                            >
                              <b-form-select-option value="true"
                                >Activo</b-form-select-option
                              >
                              <b-form-select-option value="false"
                                >Inactivo</b-form-select-option
                              >
                            </b-form-select>
                          </b-col>
                        </b-row>
                        <b-row class="text-left">
                          <b-col>
                            <br />
                            <br />
                            <b-button
                              variant="primary"
                              type="submit"
                              :disabled="
                                origenMembresiaPut.idConvenioOrigenMembresia ==
                                null
                              "
                              >Editar</b-button
                            >
                          </b-col>
                          <b-col> </b-col>
                          <b-col> </b-col>
                        </b-row>
                      </b-form>
                    </validation-observer>
                  </b-col>
                </b-row>

                <b-row>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br
                /></b-row>
              </b-tab>

              <!--
              **********************************************
              -->
              <b-tab title="Catalogo Sucursal" @click="tabConsulta(3)">
                <b-row>
                  <b-col cols="12">
                    <b-table
                      hover
                      responsive="true"
                      thead-tr-class="columnas"
                      class="parrafos"
                      id="tabla_catalogoSucursalMembresia"
                      :items="catalogoSucursalMembresia"
                      :fields="titSucursalMem"
                      :per-page="registrosPorPagina"
                      :current-page="paginaActual"
                    >
                      <template v-slot:cell(registroActivo)="row">
                        <b-alert
                          show
                          variant="success"
                          v-if="row.item.registroActivo == true"
                          >ACTIVO</b-alert
                        >
                        <b-alert show variant="danger" v-else>INACTIVO</b-alert>
                      </template>
                      <template v-slot:cell(fechaAlta)="row">
                        {{ row.item.fechaAlta | formatoFecha }}
                      </template>
                      <template v-slot:cell(fechaModificacion)="row">
                        {{ row.item.fechaModificacion | formatoFecha }}
                      </template>
                      <template v-slot:cell(editar)="row">
                        <b-button
                          variant="outline-info"
                          @click="editarFormularioSucursalMembresia(row)"
                          >Editar</b-button
                        >
                      </template>
                    </b-table>

                    <b-pagination
                      v-if="catalogoSucursalMembresia.length > 25"
                      align="center"
                      v-model="paginaActual"
                      :total-rows="catalogoSucursalMembresia.length"
                      :per-page="registrosPorPagina"
                      aria-controls="my-table1"
                    ></b-pagination>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12">
                    <br />
                    <br />
                    <br />
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <h3 class="text-left">Crear sucursal</h3>
                    <validation-observer
                      ref="post_sucursal_membresia"
                      v-slot="{ handleSubmit }"
                    >
                      <b-form
                        @submit.stop.prevent="
                          handleSubmit(postGuardarSucursalMembresia)
                        "
                      >
                        <br />
                        <br /><br />

                        <b-row>
                          <b-col align="left">
                            <validation-provider
                              name="compania"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label>Compañia:</label><validacion>*</validacion>
                              <v-select
                                label="nombreComercial"
                                id="compania"
                                v-model="compania"
                                :options="lstCompania"
                                @input="seleccinarEmpresa($event)"
                                required
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col align="left">
                            <validation-provider
                              name="plan_convenio"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label>Convenio:</label><validacion>*</validacion>
                              <v-select
                                label="nombrePlan"
                                id="plan_convenio"
                                v-model="planConvenio"
                                :options="lstPlanesConvenios"
                                @input="seleccinarPlanConvenio($event)"
                                required
                                :disabled="plan_convenio == false"
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>
                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                        </b-row>

                        <b-row class="text-left">
                          <b-col>
                            <validation-provider
                              name="sucursalMembresia"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label>Sucursal:<validacion>*</validacion></label>
                              <b-form-input
                                v-model="sucursalMembresia[0].descripcion"
                                placeholder="Sucursal"
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                                required
                              ></b-form-input>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col> </b-col>
                          <b-col> </b-col>
                        </b-row>
                        <b-row class="text-left">
                          <b-col>
                            <br />
                            <br />
                            <b-button variant="primary" type="submit"
                              >Guardar</b-button
                            >
                          </b-col>
                          <b-col> </b-col>
                          <b-col> </b-col>
                        </b-row>
                      </b-form>
                    </validation-observer>
                  </b-col>
                  <b-col cols="6">
                    <h3 class="text-left">Editar surcusal</h3>
                    <validation-observer
                      ref="put_sucursal_membresia"
                      v-slot="{ handleSubmit }"
                    >
                      <b-form
                        @submit.stop.prevent="
                          handleSubmit(putActualizarSucursalMembresia)
                        "
                      >
                        <br />
                        <br /><br />
                        <b-row class="text-left">
                          <b-col>
                            <label>Id:<validacion>*</validacion></label
                            ><b-form-input
                              v-model="sucursalMembresiaPut.idConvenioSucursal"
                              disabled
                            ></b-form-input
                          ></b-col>

                          <b-col> </b-col>
                        </b-row>
                        <b-row class="text-left">
                          <b-col align="left">
                            <validation-provider
                              name="compania"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label>Compañia:</label><validacion>*</validacion>
                              <v-select
                                label="nombreComercial"
                                id="compania"
                                v-model="compania"
                                :options="lstCompania"
                                @input="seleccinarEmpresa($event)"
                                required
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col align="left">
                            <validation-provider
                              name="plan_convenio"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label>Convenio:</label><validacion>*</validacion>
                              <v-select
                                label="nombrePlan"
                                id="plan_convenio"
                                v-model="planConvenio"
                                :options="lstPlanesConvenios"
                                @input="seleccinarPlanConvenio($event)"
                                required
                                :disabled="plan_convenio == false"
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>
                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                        </b-row>

                        <b-row class="text-left">
                          <b-col>
                            <validation-provider
                              name="sucursalMembresiaPut"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label>Sucursal:<validacion>*</validacion></label>
                              <b-form-input
                                v-model="sucursalMembresiaPut.descripcion"
                                :disabled="
                                  sucursalMembresiaPut.idConvenioSucursal ==
                                  null
                                "
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                                required
                              ></b-form-input>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <label>Estatus:<validacion>*</validacion></label>
                            <b-form-select
                              v-model="sucursalMembresiaPut.registroActivo"
                              :disabled="
                                sucursalMembresiaPut.idConvenioSucursal == null
                              "
                            >
                              <b-form-select-option value="true"
                                >Activo</b-form-select-option
                              >
                              <b-form-select-option value="false"
                                >Inactivo</b-form-select-option
                              >
                            </b-form-select>
                          </b-col>
                        </b-row>
                        <b-row class="text-left">
                          <b-col>
                            <br />
                            <br />
                            <br />
                            <b-button
                              variant="primary"
                              type="submit"
                              :disabled="
                                sucursalMembresiaPut.idConvenioSucursal == null
                              "
                              >Editar</b-button
                            >
                          </b-col>
                          <b-col> </b-col>
                          <b-col> </b-col>
                        </b-row>
                      </b-form>
                    </validation-observer>
                  </b-col>
                </b-row>

                <b-row>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br
                /></b-row>
              </b-tab>

              <!--
              **********************************************
              -->
              <b-tab title="Catalogo Membresia/poliza" @click="tabConsulta(4)">
                <b-row>
                  <b-col cols="12">
                    <b-table
                      hover
                      responsive="true"
                      thead-tr-class="columnas"
                      class="parrafos"
                      id="tabla_catalogoConvenioMembresia"
                      :items="catalogoConvenioMembresia"
                      :fields="titConvenioMem"
                      :per-page="registrosPorPagina"
                      :current-page="paginaActual"
                    >
                      <template v-slot:cell(registroActivo)="row">
                        <b-alert
                          show
                          variant="success"
                          v-if="row.item.registroActivo == true"
                          >ACTIVO</b-alert
                        >
                        <b-alert show variant="danger" v-else>INACTIVO</b-alert>
                      </template>
                      <template v-slot:cell(fechaAlta)="row">
                        {{ row.item.fechaAlta | formatoFecha }}
                      </template>
                      <template v-slot:cell(fechaModificacion)="row">
                        {{ row.item.fechaModificacion | formatoFecha }}
                      </template>
                      <template v-slot:cell(editar)="row">
                        <b-button
                          variant="outline-info"
                          @click="editarFormularioConvenioMembresia(row)"
                          >Editar</b-button
                        >
                      </template>
                    </b-table>

                    <b-pagination
                      v-if="catalogoConvenioMembresia.length > 25"
                      align="center"
                      v-model="paginaActual"
                      :total-rows="catalogoConvenioMembresia.length"
                      :per-page="registrosPorPagina"
                      aria-controls="my-table1"
                    ></b-pagination>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12">
                    <br />
                    <br />
                    <br />
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <h3 class="text-left">Crear Membresia</h3>
                    <validation-observer
                      ref="post_convenio_membresia"
                      v-slot="{ handleSubmit }"
                    >
                      <b-form
                        @submit.stop.prevent="
                          handleSubmit(postGuardarConvenioMembresia)
                        "
                      >
                        <br />
                        <br /><br />
                        <b-row>
                          <b-col align="left">
                            <validation-provider
                              name="compania"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label>Compañia:</label><validacion>*</validacion>
                              <v-select
                                label="nombreComercial"
                                id="compania"
                                v-model="compania"
                                :options="lstCompania"
                                @input="seleccinarEmpresa($event)"
                                required
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col align="left">
                            <validation-provider
                              name="plan_convenio"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label>Convenio:</label><validacion>*</validacion>
                              <v-select
                                label="nombrePlan"
                                id="plan_convenio"
                                v-model="planConvenio"
                                :options="lstPlanesConvenios"
                                @input="seleccinarPlanConvenio($event)"
                                required
                                :disabled="plan_convenio == false"
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>
                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                        </b-row>

                        <b-row class="text-left">
                          <b-col>
                            <validation-provider
                              name="convenioMembresia"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label
                                >Membresia:<validacion>*</validacion></label
                              >
                              <b-form-input
                                v-model="convenioMembresia[0].descripcion"
                                placeholder="Sucursal"
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                                required
                              ></b-form-input>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col> </b-col>
                          <b-col> </b-col>
                        </b-row>
                        <b-row class="text-left">
                          <b-col>
                            <br />
                            <br />
                            <b-button variant="primary" type="submit"
                              >Guardar</b-button
                            >
                          </b-col>
                          <b-col> </b-col>
                          <b-col> </b-col>
                        </b-row>
                      </b-form>
                    </validation-observer>
                  </b-col>
                  <b-col cols="6">
                    <h3 class="text-left">Editar Membresia</h3>
                    <validation-observer
                      ref="put_convenio_membresia"
                      v-slot="{ handleSubmit }"
                    >
                      <b-form
                        @submit.stop.prevent="
                          handleSubmit(putActualizarConvenioMembresia)
                        "
                      >
                        <br />
                        <br /><br />
                        <b-row class="text-left">
                          <b-col>
                            <label>Id:<validacion>*</validacion></label
                            ><b-form-input
                              v-model="convenioMembresiaPut.idconvenioMembresia"
                              disabled
                            ></b-form-input
                          ></b-col>

                          <b-col> </b-col>
                        </b-row>
                        <b-row class="text-left">
                          <b-col align="left">
                            <validation-provider
                              name="compania"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label>Compañia:</label><validacion>*</validacion>
                              <v-select
                                label="nombreComercial"
                                id="compania"
                                v-model="compania"
                                :options="lstCompania"
                                @input="seleccinarEmpresa($event)"
                                required
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col align="left">
                            <validation-provider
                              name="plan_convenio"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label>Convenio:</label><validacion>*</validacion>
                              <v-select
                                label="nombrePlan"
                                id="plan_convenio"
                                v-model="planConvenio"
                                :options="lstPlanesConvenios"
                                @input="seleccinarPlanConvenio($event)"
                                required
                                :disabled="plan_convenio == false"
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>
                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                        </b-row>

                        <b-row class="text-left">
                          <b-col>
                            <validation-provider
                              name="convenioMembresiaPut"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label
                                >Membresia:<validacion>*</validacion></label
                              >
                              <b-form-input
                                v-model="convenioMembresiaPut.descripcion"
                                :disabled="
                                  convenioMembresiaPut.idconvenioMembresia ==
                                  null
                                "
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                                required
                              ></b-form-input>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <label>Estatus:<validacion>*</validacion></label>
                            <b-form-select
                              v-model="convenioMembresiaPut.registroActivo"
                              :disabled="
                                convenioMembresiaPut.idconvenioMembresia == null
                              "
                            >
                              <b-form-select-option value="true"
                                >Activo</b-form-select-option
                              >
                              <b-form-select-option value="false"
                                >Inactivo</b-form-select-option
                              >
                            </b-form-select>
                          </b-col>
                        </b-row>
                        <b-row class="text-left">
                          <b-col>
                            <br />
                            <br />
                            <br />
                            <b-button
                              variant="primary"
                              type="submit"
                              :disabled="
                                convenioMembresiaPut.idconvenioMembresia == null
                              "
                              >Editar</b-button
                            >
                          </b-col>
                          <b-col> </b-col>
                          <b-col> </b-col>
                        </b-row>
                      </b-form>
                    </validation-observer>
                  </b-col>
                </b-row>

                <b-row>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br
                /></b-row>
              </b-tab>

              <!--
              **********************************************
              -->
              <b-tab title="Convenios Membresias" @click="tabConsulta(5)">
                <b-row>
                  <b-col cols="4">
                  </b-col>
                  <b-col cols="4">
                    <b-col>
                      <label>Compañia:</label><validacion>*</validacion>
                      <v-select
                        label="nombreComercial"
                        id="compania"
                        v-model="companiaBusqueda"
                        :options="lstCompaniaBuscador"
                        @input="seleccinarEmpresaBusqueda($event)"
                        required
                      >
                        <span slot="no-options">No hay datos...</span>
                      </v-select>
                    </b-col>

                    <b-col>
                      <label>Convenio:</label><validacion>*</validacion>
                      <v-select
                        label="nombrePlan"
                        id="plan_convenio"
                        v-model="planConvenioBusqueda"
                        :options="lstPlanesConveniosBuscador"
                        @input="seleccinarPlanConvenioBusqueda($event)"
                        required
                        :disabled="plan_convenio == false"
                      >
                        <span slot="no-options">No hay datos...</span>
                      </v-select>

                      <br />
                    </b-col>
                  </b-col>
                  <b-col cols="4"> </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12">
                    <b-table
                      hover
                      responsive="true"
                      thead-tr-class="columnas"
                      class="parrafos"
                      id="tabla_catalogoConvenioMembresia"
                      :items="catalogoConvenioMembresiaEspecial"
                      :fields="titConvenioMemEspecial"
                      :per-page="registrosPorPagina"
                      :current-page="paginaActual"
                    >
                      <template v-slot:cell(registroActivo)="row">
                        <b-alert
                          show
                          variant="success"
                          v-if="row.item.registroActivo == true"
                          >ACTIVO</b-alert
                        >
                        <b-alert show variant="danger" v-else>INACTIVO</b-alert>
                      </template>
                      <template v-slot:cell(fechaAlta)="row">
                        {{ row.item.fechaAlta | formatoFecha }}
                      </template>
                      <template v-slot:cell(fechaModificacion)="row">
                        {{ row.item.fechaModificacion | formatoFecha }}
                      </template>
                    </b-table>

                    <b-pagination
                      v-if="catalogoConvenioMembresiaEspecial.length > 25"
                      align="center"
                      v-model="paginaActual"
                      :total-rows="catalogoConvenioMembresiaEspecial.length"
                      :per-page="registrosPorPagina"
                      aria-controls="my-table1"
                    ></b-pagination>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12">
                    <br />
                    <br />
                    <br />
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <h3 class="text-left">Crear Convenio Membresia</h3>
                    <validation-observer
                      ref="post_convenio_membresia"
                      v-slot="{ handleSubmit }"
                    >
                      <b-form
                        @submit.stop.prevent="
                          handleSubmit(postGuardarMembresiaMembresia)
                        "
                      >
                        <br />
                        <br /><br />
                        <b-row>
                          <b-col align="left">
                            <validation-provider
                              name="compania"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label>Compañia:</label><validacion>*</validacion>
                              <v-select
                                label="nombreComercial"
                                id="compania"
                                v-model="compania"
                                :options="lstCompania"
                                @input="seleccinarEmpresa($event)"
                                required
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col align="left">
                            <validation-provider
                              name="plan_convenio"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label>Convenio:</label><validacion>*</validacion>
                              <v-select
                                label="nombrePlan"
                                id="plan_convenio"
                                v-model="planConvenio"
                                :options="lstPlanesConvenios"
                                @input="seleccinarPlanConvenio($event)"
                                required
                                :disabled="plan_convenio == false"
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>
                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                        </b-row>

                        <b-row class="text-left">
                          <b-col>
                            <validation-provider
                              name="tipomembresiaconvenioMembresia"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label
                                >Tipo Membresia:<validacion
                                  >*</validacion
                                ></label
                              >

                              <v-select
                                label="descripcion"
                                id="cm_tipoMembresia"
                                v-model="cm_tipoMembresia"
                                :options="cm_tipoMembresia_lista"
                                @input="
                                  seleccinarcm_tipoMembresia_lista($event)
                                "
                                required
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>
                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <validation-provider
                              name="origenmembresiaconvenioMembresia"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label
                                >Origen Membresia:<validacion
                                  >*</validacion
                                ></label
                              >
                              <v-select
                                label="descripcion"
                                id="cm_origenMembresia"
                                v-model="cm_origenMembresia"
                                :options="cm_origenMembresia_lista"
                                @input="
                                  seleccinarcm_origenMembresia_lista($event)
                                "
                                required
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                        </b-row>

                        <b-row class="text-left">
                          <b-col>
                            <validation-provider
                              name="sucursalmembresiaconvenioMembresia"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label>sucursal:<validacion>*</validacion></label>

                              <v-select
                                label="descripcion"
                                id="cm_sucursalMembresia"
                                v-model="cm_sucursalMembresia"
                                :options="cm_sucursalMembresia_lista"
                                @input="
                                  seleccinarcm_sucursalMembresia_lista($event)
                                "
                                required
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <validation-provider
                              name="membresiapolizamembresiaconvenioMembresia"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label
                                >Membresia/Poliza:<validacion
                                  >*</validacion
                                ></label
                              >
                              <v-select
                                label="descripcion"
                                id="cm_membresiaMembresia"
                                v-model="cm_membresiaMembresia"
                                :options="cm_membresiaMembresia_lista"
                                @input="
                                  seleccinarcm_membresiaMembresia_lista($event)
                                "
                                required
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                              >
                                <span slot="no-options">No hay datos...</span>
                              </v-select>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                        </b-row>

                        <b-row class="text-left">
                          <b-col>
                            <validation-provider
                              name="numeromaximoonvenioMembresia"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label
                                >Número Máximo de integrantes:<validacion
                                  >*</validacion
                                ></label
                              >
                              <b-form-input
                                type="number"
                                v-model="
                                  convenioMembresiaEspecial[0].numIntegrantes
                                "
                                placeholder="Número Máximo de integrantes"
                                :state="
                                  motivoSlot.errors[0]
                                    ? false
                                    : motivoSlot.valid
                                    ? true
                                    : null
                                "
                                required
                              ></b-form-input>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col> </b-col>
                        </b-row>

                        <b-row class="text-left">
                          <b-col>
                            <validation-provider
                              name="vigenciainiconvenioMembresia"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label
                                >Inicio de vigencia:<validacion
                                  >*</validacion
                                ></label
                              >
                              <b-form-datepicker
                                inline
                                v-model="
                                  convenioMembresiaEspecial[0].vigenciaInicio
                                "
                                placeholder="Selecciona una fecha"
                              ></b-form-datepicker>

                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <validation-provider
                              name="vigenciafinconvenioMembresia"
                              :rules="{ required: true }"
                              v-slot="motivoSlot"
                            >
                              <label
                                >Fin de vigencia:<validacion
                                  >*</validacion
                                ></label
                              >

                              <b-form-datepicker
                                inline
                                v-model="
                                  convenioMembresiaEspecial[0].vigenciaFin
                                "
                                placeholder="Selecciona una fecha"
                              ></b-form-datepicker>
                              <validacion
                                :texto="
                                  motivoSlot.errors[0]
                                    ? motivoSlot.errors[0]
                                    : ''
                                "
                              ></validacion>
                            </validation-provider>
                          </b-col>
                        </b-row>

                        <b-row class="text-left">
                          <b-col>
                            <br />
                            <br />
                            <b-button variant="primary" type="submit"
                              >Guardar</b-button
                            >
                          </b-col>
                          <b-col> </b-col>
                          <b-col> </b-col>
                        </b-row>
                      </b-form>
                    </validation-observer>
                  </b-col>
                  <b-col cols="6"> </b-col>
                </b-row>

                <b-row>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br
                /></b-row>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
      <b-row> </b-row>

      <b-row>
        <b-col cols="12"> <br /><br /> </b-col>
      </b-row>

      <b-row>
        <b-col cols="12"
          ><br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>
import Header from "@/components/Header.vue";

export default {
  name: "TipoMembresia",
  components: {
    Header,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    loading: false,
    registrosPorPagina: 25,
    paginaActual: 1,
    /*
     **********************************************
     */
    catalogoTipoMembresia: [], //listado del back
    titTipoMem: [
      { key: "idConvenioTipoMembresia", label: "id", sortable: true },
      { key: "descripcion", label: "tipo membresia", sortable: true },
      { key: "registroActivo", label: "activo", sortable: true },
      { key: "fechaAlta", label: "Alta", sortable: true },
      { key: "fechaModificacion", label: "Modificación", sortable: true },
      { key: "editar", label: "editar", sortable: true },
    ], //titulos de tabla
    tipoMembresia: [], //datos a enviar al post
    tipoMembresiaPut: [], //datos a enviar al put

    /*
     **********************************************
     */
    catalogoOrigenMembresia: [], //listado del back
    titOrigenMem: [
      { key: "idConvenioOrigenMembresia", label: "id", sortable: true },
      { key: "descripcion", label: "origen membresia", sortable: true },
      { key: "registroActivo", label: "activo", sortable: true },
      { key: "fechaAlta", label: "Alta", sortable: true },
      { key: "fechaModificacion", label: "Modificación", sortable: true },
      { key: "editar", label: "editar", sortable: true },
    ], //titulos de tabla
    origenMembresia: [], //datos a enviar al post
    origenMembresiaPut: [], //datos a enviar al put
    /*
     **********************************************
     */
    catalogoSucursalMembresia: [], //listado del back
    titSucursalMem: [
      { key: "idConvenioSucursal", label: "id", sortable: true },
      { key: "descripcion", label: "sucursal", sortable: true },
      { key: "nombreEmpresa", label: "empresa", sortable: true },
      { key: "nombrePlan", label: "convenio", sortable: true },
      { key: "registroActivo", label: "activo", sortable: true },
      { key: "fechaAlta", label: "Alta", sortable: true },
      { key: "fechaModificacion", label: "Modificación", sortable: true },
      { key: "editar", label: "editar", sortable: true },
    ], //titulos de tabla
    sucursalMembresia: [
      {
        idCompania: null,
        idPlan: null,
        descripcion: null,
        idUsuarioAlta: null,
        idUsuarioModificacion: null,
      },
    ], //datos a enviar al post
    sucursalMembresiaPut: [], //datos a enviar al put
    /*
     **********************************************
     */
    compania: null, //variable donde se guarda el ARRAY de la opcion seleccionada
    planConvenio: null, //variable donde se guarda el ARRAY de la opcion seleccionada
    plan_convenio: false, //bandera para indicar si es disabled o no el selectcuando ya hay datos
    lstCompania: [],
    lstCompaniaBuscador: [],
    lstPlanesConvenios: [],
    lstPlanesConveniosBuscador : [],

    /*
     **********************************************
     */
    catalogoConvenioMembresia: [], //listado del back
    titConvenioMem: [
      { key: "idconvenioMembresia", label: "id", sortable: true },
      { key: "descripcion", label: "membresia/poliza", sortable: true },
      { key: "nombreEmpresa", label: "empresa", sortable: true },
      { key: "nombrePlan", label: "convenio", sortable: true },
      { key: "registroActivo", label: "activo", sortable: true },
      { key: "fechaAlta", label: "Alta", sortable: true },
      { key: "fechaModificacion", label: "Modificación", sortable: true },
      { key: "editar", label: "editar", sortable: true },
    ], //titulos de tabla
    convenioMembresia: [
      {
        idCompania: null,
        idPlan: null,
        descripcion: null,
        idUsuarioAlta: null,
        idUsuarioModificacion: null,
      },
    ], //datos a enviar al post
    convenioMembresiaPut: [], //datos a enviar al put

    /*
     **********************************************
     */
    companiaBusqueda: null,
    planConvenioBusqueda: null,

    catalogoConvenioMembresiaEspecial: [],
    titConvenioMemEspecial: [
      { key: "idConvenioEspecial", label: "id", sortable: true },
      { key: "nombreEmpresa", label: "empresa", sortable: true },
      { key: "nombrePlan", label: "convenio", sortable: true },
      { key: "tipoMembresia", label: "tipoMembresia", sortable: true },
      { key: "origenMembresia", label: "origenMembresia", sortable: true },
      { key: "sucursal", label: "sucursal", sortable: true },
      { key: "convenioMembresia", label: "Membresia/Poliza", sortable: true },
      {
        key: "numIntegrantes",
        label: "Numero máximo de integrantes",
        sortable: true,
      },
      { key: "altaIntegrantes", label: "Integrantes actuales", sortable: true },
      { key: "vigenciaInicio", label: "Inicio de Vigencia", sortable: true },
      { key: "vigenciaFin", label: "Fin de vigencia", sortable: true },
      { key: "registroActivo", label: "activo", sortable: true },
      { key: "fechaAlta", label: "Alta", sortable: true },
      { key: "fechaModificacion", label: "Modificación", sortable: true },
    ], //titulos de tabla
    convenioMembresiaEspecial: [
      {
        idCompania: null,
        idPlan: null,
        idConvenioTipoMembresia: null,
        idConvenioOrigenMembresia: null,
        idConvenioSucursal: null,
        idConvenioMembresia: null,

        numIntegrantes: null,
        vigenciaInicio: null,
        vigenciaFin: null,
        idUsuarioAlta: null,
        idUsuarioModificacion: null,
      },
    ], //datos a enviar al post
    convenioMembresiaEspecialPut: [], //datos a enviar al put

    cm_tipoMembresia_lista: [],
    cm_origenMembresia_lista: [],
    cm_sucursalMembresia_lista: [],
    cm_membresiaMembresia_lista: [],

    cm_tipoMembresia: null, //variable donde se guarda el ARRAY de la opcion seleccionada de tipo membresia
    cm_origenMembresia: null, //variable donde se guarda el ARRAY de la opcion seleccionada de origen membresia
    cm_sucursalMembresia: null, //variable donde se guarda el ARRAY de la opcion seleccionada de sucursal
    cm_membresiaMembresia: null, //variable donde se guarda el ARRAY de la opcion seleccionada de  membresia

    /*
     **********************************************
     */
  }),

  mounted() {
    this.getTipoMembresia();
    this.obtenerListaEmpresas();
    this.obtenerListaEmpresasBuscador();

    this.getTipoMembresiaPorEstatus();
    this.getOrigenMembresiaPorEstatus();
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();
  },
  computed: {},

  methods: {
    /*
     * c_convenio_tipo_membresia
     * c_convenio_origen_membresia
     * c_convenio_sucursal
     * c_convenio_membresia
     * d_convenio_especial
     */
    /*
    

    /*
     **********************************************
     */
    tabConsulta(numero) {
      this.paginaActual = 1;
      this.tipoMembresia = [];
      this.tipoMembresiaPut = [];
      this.origenMembresia = [];
      this.origenMembresiaPut = [];

      this.compania = null;
      this.planConvenio = null;
      this.plan_convenio = false;
      this.sucursalMembresia = [
        {
          idCompania: null,
          idPlan: null,
          descripcion: null,
          idUsuarioAlta: this.idUsuario,
          idUsuarioModificacion: this.idUsuario,
        },
      ];
      this.sucursalMembresiaPut = [];
      this.convenioMembresia = [
        {
          idCompania: null,
          idPlan: null,
          descripcion: null,
          idUsuarioAlta: this.idUsuario,
          idUsuarioModificacion: this.idUsuario,
        },
      ];
      this.convenioMembresiaPut = [];
      this.convenioMembresiaEspecial = [
        {
          idCompania: null,
          idPlan: null,
          idConvenioTipoMembresia: null,
          idConvenioOrigenMembresia: null,
          idConvenioSucursal: null,
          idConvenioMembresia: null,

          numIntegrantes: null,
          vigenciaInicio: null,
          vigenciaFin: null,
          idUsuarioAlta: this.idUsuario,
          idUsuarioModificacion: this.idUsuario,
        },
      ];
      this.convenioMembresiaEspecialPut = [];

      this.cm_tipoMembresia = null;
      this.cm_origenMembresia = null;
      this.cm_sucursalMembresia = null;
      this.cm_membresiaMembresia = null;

      switch (numero) {
        case 1:
          this.getTipoMembresia();
          break;
        case 2:
          this.getOrigenMembresia();
          break;
        case 3:
          this.getSucursalMembresia();
          break;
        case 4:
          this.getConvenioMembresia();
          break;
        case 5:
          /**/
          this.getTipoMembresiaPorEstatus();
          this.getOrigenMembresiaPorEstatus();
          break;
        default:
          this.getTipoMembresia();
          break;
      }
    },
    obtenerListaEmpresasBuscador() {
      this.$http
        .get(this.$api + "empresas/obtener/empresasconconvenios/sinestatus")
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            this.lstCompaniaBuscador = [];
            resultado.forEach((item, index) => {
              item.id = index;
              this.lstCompaniaBuscador.push(item);
            });
          }
        })
        .catch(function (error) {
          console.error(error);
          this.$swal({
            icon: "error",
            text: "A ocurrido un error, intentalo más tarde.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
        });
    },
    
    obtenerListaEmpresas() {
      const parametros = {estatus: true}
      this.$http
        .post(this.$api + "empresas/obtener/empresasconconvenios/porestatus", parametros)
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            this.lstCompania = [];
            resultado.forEach((item, index) => {
              item.id = index;
              this.lstCompania.push(item);
            });
          }
        })
        .catch(function (error) {
          console.error(error);
          this.$swal({
            icon: "error",
            text: "A ocurrido un error, intentalo más tarde.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
        });
    },
    seleccinarEmpresa(evento) {
      if (evento == null) {
        this.lstPlanesConvenios = [];
        this.sucursalMembresia[0].idCompania = null;
        this.convenioMembresia[0].idCompania = null;
        this.convenioMembresiaEspecial[0].idCompania = null;
      } else {
        this.lstPlanesConvenios = [];
        this.sucursalMembresia[0].idCompania = evento.idEmpresa;
        this.convenioMembresia[0].idCompania = evento.idEmpresa;
        this.convenioMembresiaEspecial[0].idCompania = evento.idEmpresa;

        // this.sucursalMembresia.push({idCompania:  evento.idEmpresa});
        this.obtenerPlanesEmpresa(evento);
      }
    },
    seleccinarEmpresaBusqueda(evento) {
      if (evento !== null) {
        this.companiaBusqueda = evento;        
        this.planConvenioBusqueda = null;
        this.obtenerPlanesEmpresaBuscador(evento);
      }
    },
    obtenerPlanesEmpresa(empresa) {
      this.planConvenio = null;
      this.plan_convenio = false;
      const parametros = {idEmpresa: empresa.idEmpresa, estatus: true}
      var url = "empresas/obtener/convenios/porestatus";

      this.$http
        .post(this.$api + url, parametros)
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            this.lstPlanesConvenios = [];
            resultado.forEach((item, index) => {
              item.id = index;
              this.lstPlanesConvenios.push(item);
            });
          }
          if (this.lstPlanesConvenios.length <= 0) {
            this.blnRegistros = true;
          }
        })
        .catch(function (error) {
          console.error(error);
          this.$swal({
            icon: "error",
            text: "A ocurrido un error, intentalo más tarde.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
        })
        .finally(() => {
          this.plan_convenio = true;
        });
    },
    obtenerPlanesEmpresaBuscador(empresa) {
      this.planConvenio = null;
      this.plan_convenio = false;
      const parametros = {idEmpresa: empresa.idEmpresa}
      var url = "empresas/obtener/convenios/sinestatus";

      this.$http
        .post(this.$api + url, parametros)
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            this.lstPlanesConveniosBuscador = [];
            resultado.forEach((item, index) => {
              item.id = index;
              this.lstPlanesConveniosBuscador.push(item);
            });
          }
          if (this.lstPlanesConvenios.length <= 0) {
            this.blnRegistros = true;
          }
        })
        .catch(function (error) {
          console.error(error);
          this.$swal({
            icon: "error",
            text: "A ocurrido un error, intentalo más tarde.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
        })
        .finally(() => {
          this.plan_convenio = true;
        });
    },
    seleccinarPlanConvenio(evento) {
      if (evento == null) {
        this.sucursalMembresia[0].idPlan = null;
        this.convenioMembresia[0].idPlan = null;
        this.convenioMembresiaEspecial[0].idPlan = null;
        this.cm_sucursalMembresia = null;
        this.cm_membresiaMembresia = null;
        this.cm_sucursalMembresia_lista = [];
        this.cm_membresiaMembresia_lista = [];
        this.convenioMembresiaPut.idPlan = null;
      } else {
        this.sucursalMembresia[0].idPlan = evento.idPlan;
        this.convenioMembresia[0].idPlan = evento.idPlan;
        this.convenioMembresiaEspecial[0].idPlan = evento.idPlan;
        this.getSucursalMembresiaPorEstatus(evento.idPlan);
        this.getMembresiaMembresiaPorEstatus(evento.idPlan);
        this.convenioMembresiaPut.idPlan = evento.idPlan;
      }
    },
    seleccinarPlanConvenioBusqueda(evento) {
      if (evento !== null) {
        this.planConvenioBusqueda = evento;
        this.getConvenioMembresiaEspecial(evento.idPlan);
      }
    },
    /*
     **********************************************
     */
    getTipoMembresia() {
      this.loading = true;
      this.catalogoTipoMembresia = [];

      this.$http
        .get(this.$api + "conveniomembresias/tipomembresia")
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.catalogoTipoMembresia = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    postGuardarTipoMembresia() {
      this.loading = true;
      const tipoMembresiaDTO = {
        idConvenioTipoMembresia: null,
        descripcion: this.tipoMembresia.descripcion,
        idUsuarioAlta: this.$localStorageService.getIdUsuario(),
        idUsuarioModificacion: this.$localStorageService.getIdUsuario(),
      };
      this.$http
        .post(this.$api + "conveniomembresias/tipomembresia", tipoMembresiaDTO)
        .then((response) => {

          this.$swal.fire({
            icon: "success",
            title: "Aviso",
            text: response.data.message,
          });
        })
        .catch((error) => {
          var message = error.response.data.message
            ? error.response.data.message
            : "Error al crear el registro";
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: message,
          });
        })
        .finally(() => {
          (this.loading = false), this.tabConsulta(1);
        });
    },
    editarFormularioTipoMembresia(row) {

      this.tipoMembresiaPut = {
        idConvenioTipoMembresia: row.item.idConvenioTipoMembresia,
        descripcion: row.item.descripcion,
        registroActivo: row.item.registroActivo,
        idUsuarioModificacion: this.$localStorageService.getIdUsuario(),
      };
    },
    putActualizarTipoMembresia() {
      this.loading = true;
      this.$http
        .put(
          this.$api + "conveniomembresias/tipomembresia",
          this.tipoMembresiaPut
        )
        .then((response) => {
          this.$swal.fire({
            icon: "success",
            title: "Aviso",
            text: response.data.message,
          });
        })
        .catch((error) => {
          var message = error.response.data.message
            ? error.response.data.message
            : "Error al actualizar el registro";
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: message,
          });
        })
        .finally(() => {
          (this.loading = false), this.tabConsulta(1);
        });
    },
    /*
     **********************************************
     */
    getOrigenMembresia() {
      this.loading = true;
      this.catalogoOrigenMembresia = [];

      this.$http
        .get(this.$api + "conveniomembresias/origenmembresia")
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.catalogoOrigenMembresia = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    postGuardarOrigenMembresia() {
      this.loading = true;
      const origenMembresiaDTO = {
        idConvenioTipoMembresia: null,
        descripcion: this.origenMembresia.descripcion,
        idUsuarioAlta: this.$localStorageService.getIdUsuario(),
        idUsuarioModificacion: this.$localStorageService.getIdUsuario(),
      };
      this.$http
        .post(
          this.$api + "conveniomembresias/origenmembresia",
          origenMembresiaDTO
        )
        .then((response) => {

          this.$swal.fire({
            icon: "success",
            title: "Aviso",
            text: response.data.message,
          });
        })
        .catch((error) => {
          var message = error.response.data.message
            ? error.response.data.message
            : "Error al crear el registro";
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: message,
          });
        })
        .finally(() => {
          (this.loading = false), this.tabConsulta(2);
        });
    },
    editarFormularioOrigenMembresia(row) {
      this.origenMembresiaPut = {
        idConvenioOrigenMembresia: row.item.idConvenioOrigenMembresia,
        descripcion: row.item.descripcion,
        registroActivo: row.item.registroActivo,
        idUsuarioModificacion: this.$localStorageService.getIdUsuario(),
      };
    },
    putActualizarOrigenMembresia() {
      this.loading = true;
      this.$http
        .put(
          this.$api + "conveniomembresias/origenmembresia",
          this.origenMembresiaPut
        )
        .then((response) => {
          this.$swal.fire({
            icon: "success",
            title: "Aviso",
            text: response.data.message,
          });
        })
        .catch((error) => {
          var message = error.response.data.message
            ? error.response.data.message
            : "Error al actualizar el registro";
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: message,
          });
        })
        .finally(() => {
          (this.loading = false), this.tabConsulta(2);
        });
    },
    /*
     **********************************************
     */
    getSucursalMembresia() {
      this.loading = true;
      this.catalogoSucursalMembresia = [];

      this.$http
        .get(this.$api + "conveniomembresias/sucursal")
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.catalogoSucursalMembresia = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    postGuardarSucursalMembresia() {
      this.loading = true;

      this.$http
        .post(
          this.$api + "conveniomembresias/sucursal",
          this.sucursalMembresia[0]
        )
        .then((response) => {

          this.$swal.fire({
            icon: "success",
            title: "Aviso",
            text: response.data.message,
          });
          this.tabConsulta(3);
        })
        .catch((error) => {
          var message = error.response.data.message
            ? error.response.data.message
            : "Error al crear el registro";
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: message,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editarFormularioSucursalMembresia(row) {
      this.loading = true;
      this.sucursalMembresiaPut = {
        idConvenioSucursal: row.item.idConvenioSucursal,
        descripcion: row.item.descripcion,
        registroActivo: row.item.registroActivo,
        idPlan: row.item.idPlan,
        nombrePlan: row.item.nombrePlan,
        idUsuarioModificacion: this.$localStorageService.getIdUsuario(),
      };

      this.lstCompania.forEach;

      this.lstCompania.forEach((elemento) => {
        if (elemento.idEmpresa == row.item.idEmpresa) {
          this.compania = elemento;
          this.obtenerPlanesEmpresa(elemento);
        }
      });

      setTimeout(() => {
        this.lstPlanesConvenios.forEach((elemento) => {
          if (elemento.idPlan == row.item.idPlan) {
            this.planConvenio = elemento;
          }
        });
        this.loading = false;
      }, 2000);
    },
    putActualizarSucursalMembresia() {
      this.loading = true;
      this.$http
        .put(
          this.$api + "conveniomembresias/sucursal",
          this.sucursalMembresiaPut
        )
        .then((response) => {
          this.$swal.fire({
            icon: "success",
            title: "Aviso",
            text: response.data.message,
          });
        })
        .catch((error) => {
          var message = error.response.data.message
            ? error.response.data.message
            : "Error al actualizar el registro";
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: message,
          });
        })
        .finally(() => {
          (this.loading = false), this.tabConsulta(3);
        });
    },

    obtenerPlanesEmpresaEditar(empresa) {
      this.planConvenio = null;
      this.plan_convenio = false;
      const parametros = {idEmpresa: empresa.idEmpresa}
      var url = "empresas/obtener/convenios";

      this.$http
        .post(this.$api + url, parametros)
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            this.lstPlanesConvenios = [];
            resultado.forEach((item, index) => {
              item.id = index;
              this.lstPlanesConvenios.push(item);
            });
          }
          if (this.lstPlanesConvenios.length <= 0) {
            this.blnRegistros = true;
          }
        })
        .catch(function (error) {
          console.error(error);
          this.$swal({
            icon: "error",
            text: "A ocurrido un error, intentalo más tarde.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
        })
        .finally(() => {
          this.plan_convenio = true;
        });
    },
    /*
     **********************************************
     */
    getConvenioMembresia() {
      this.loading = true;
      this.catalogoConvenioMembresia = [];

      this.$http
        .get(this.$api + "conveniomembresias/membresia")
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.catalogoConvenioMembresia = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    postGuardarConvenioMembresia() {
      this.loading = true;

      this.$http
        .post(
          this.$api + "conveniomembresias/membresia",
          this.convenioMembresia[0]
        )
        .then((response) => {

          this.$swal.fire({
            icon: "success",
            title: "Aviso",
            text: response.data.message,
          });
          this.tabConsulta(4);
        })
        .catch((error) => {
          console.error(error);
          var message = error.response.data.message
            ? error.response.data.message
            : "Error al crear el registro";
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: message,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editarFormularioConvenioMembresia(row) {
      this.loading = true;
      this.convenioMembresiaPut = {
        idconvenioMembresia: row.item.idconvenioMembresia,
        descripcion: row.item.descripcion,
        registroActivo: row.item.registroActivo,
        idPlan: row.item.idPlan,
        nombrePlan: row.item.nombrePlan,
        idUsuarioModificacion: this.$localStorageService.getIdUsuario(),
      };

      this.lstCompania.forEach;

      this.lstCompania.forEach((elemento) => {
        if (elemento.idEmpresa == row.item.idEmpresa) {
          this.compania = elemento;
          this.obtenerPlanesEmpresa(elemento);
        }
      });

      setTimeout(() => {
        this.lstPlanesConvenios.forEach((elemento) => {
          if (elemento.idPlan == row.item.idPlan) {
            this.planConvenio = elemento;
          }
        });
        this.loading = false;
      }, 2000);
    },
    putActualizarConvenioMembresia() {
      this.loading = true;
      this.$http
        .put(
          this.$api + "conveniomembresias/membresia",
          this.convenioMembresiaPut
        )
        .then((response) => {
          this.$swal.fire({
            icon: "success",
            title: "Aviso",
            text: response.data.message,
          });
        })
        .catch((error) => {
          var message = error.response.data.message
            ? error.response.data.message
            : "Error al actualizar el registro";
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: message,
          });
        })
        .finally(() => {
          (this.loading = false), this.tabConsulta(4);
        });
    },

    /*
     **********************************************
     */

    getConvenioMembresiaEspecial(idPlan) {
      this.loading = true;
      this.catalogoConvenioMembresiaEspecial = [];

      this.$http
        .get(
          this.$api +
            "conveniomembresias/conveniomembresiaespecial?idPlan=" +
            idPlan
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.catalogoConvenioMembresiaEspecial = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getTipoMembresiaPorEstatus() {
      this.loading = true;
      this.cm_tipoMembresia_lista = [];

      this.$http
        .get(
          this.$api + "conveniomembresias/tipomembresia/estatus?estatus=true"
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.cm_tipoMembresia_lista = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    seleccinarcm_tipoMembresia_lista(event) {
      this.convenioMembresiaEspecial[0].idConvenioTipoMembresia =
        event.idConvenioTipoMembresia;
    },

    getOrigenMembresiaPorEstatus() {
      this.loading = true;
      this.cm_origenMembresia_lista = [];

      this.$http
        .get(
          this.$api + "conveniomembresias/origenmembresia/estatus?estatus=true"
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.cm_origenMembresia_lista = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    seleccinarcm_origenMembresia_lista(event) {
      this.convenioMembresiaEspecial[0].idConvenioOrigenMembresia =
        event.idConvenioOrigenMembresia;
    },
    getSucursalMembresiaPorEstatus(idPlan) {
      this.loading = true;
      this.cm_sucursalMembresia_lista = [];

      this.$http
        .get(
          this.$api +
            "conveniomembresias/sucursal/estatus/plan/?estatus=true&idPlan=" +
            idPlan
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.cm_sucursalMembresia_lista = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    seleccinarcm_sucursalMembresia_lista(event) {
      if (event == null) {
        this.convenioMembresiaEspecial[0].idConvenioSucursal = null;
      } else {
        this.convenioMembresiaEspecial[0].idConvenioSucursal =
          event.idConvenioSucursal;
      }
    },

    getMembresiaMembresiaPorEstatus(idPlan) {
      this.loading = true;
      this.cm_membresiaMembresia_lista = [];

      this.$http
        .get(
          this.$api +
            "conveniomembresias/membresia/estatus/plan/?estatus=true&idPlan=" +
            idPlan
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.cm_membresiaMembresia_lista = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    seleccinarcm_membresiaMembresia_lista(event) {
      if (event == null) {
        this.convenioMembresiaEspecial[0].idConvenioMembresia = null;
      } else {
        this.convenioMembresiaEspecial[0].idConvenioMembresia =
          event.idconvenioMembresia;
      }
    },
    postGuardarMembresiaMembresia() {
      this.loading = true;

      var dia1 = new Date(this.convenioMembresiaEspecial[0].vigenciaInicio);
      dia1.setHours(0, 0, 0, 0);
      var fechaI = this.$moment(dia1).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      var dia2 = new Date(this.convenioMembresiaEspecial[0].vigenciaInicio);
      dia2.setHours(23, 60, 59, 999);
      var fechaF = this.$moment(dia2).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      this.convenioMembresiaEspecial[0].vigenciaInicio = fechaI;
      this.convenioMembresiaEspecial[0].vigenciaFin = fechaF;

      this.convenioMembresiaEspecial[0].idUsuarioAlta = this.idUsuario;
      this.convenioMembresiaEspecial[0].idUsuarioModificacion = this.idUsuario;

      this.$http
        .post(
          this.$api + "conveniomembresias/conveniomembresiaespecial",
          this.convenioMembresiaEspecial[0]
        )
        .then((response) => {

          this.$swal.fire({
            icon: "success",
            title: "Aviso",
            text: response.data.message,
          });
          this.tabConsulta(5);
        })
        .catch((error) => {
          var message = error.response.data.message
            ? error.response.data.message
            : "Error al crear el registro";
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: message,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /*
     **********************************************
     */

    /*
     **********************************************
     */

    /*
     **********************************************
     */

    /*
     **********************************************
     */
  },
};
</script>

<style>
</style>